/**
 * 顶部 Banner 一级工作域导航配置
 * 工作台｜客户｜方案｜交付｜服务｜资产｜管理
 */
export type TopNavItem = {
  key: string;
  path: string;
  label: string;
  icon: string;
  description: string;
};

export const TOP_NAV_ITEMS: TopNavItem[] = [
  {
    key: 'workbench',
    path: '/workbench',
    label: '工作台',
    icon: 'dashboard',
    description: '统一待办、风险、动态、经营看板',
  },
  {
    key: 'customer',
    path: '/customer',
    label: '客户',
    icon: 'team',
    description: '客户账户与长期转型上下文',
  },
  {
    key: 'solution',
    path: '/solution',
    label: '方案',
    icon: 'rise',
    description: '调研、诊断、业务蓝图、应用规划、报价、转项目',
  },
  {
    key: 'delivery',
    path: '/delivery',
    label: '交付',
    icon: 'folderOpen',
    description: '签约后的项目实施全过程，以项目作为唯一工作空间',
  },
  {
    key: 'service',
    path: '/service',
    label: '服务',
    icon: 'customerService',
    description: '上线后的工单、反馈、健康度、二期需求、续费增购',
  },
  {
    key: 'asset',
    path: '/asset',
    label: '资产',
    icon: 'book',
    description: '方法论、模板、案例、Prompt、Agent 工作流、SOP、复盘资产',
  },
  {
    key: 'admin',
    path: '/admin',
    label: '管理',
    icon: 'setting',
    description: '权限、字典、流程、计价、AI、Agent、集成、安全审计',
  },
];

/** 根据当前路由路径，返回激活的顶部工作域 key */
export const getActiveTopNavKey = (pathname: string): string | undefined => {
  if (pathname.startsWith('/methodology-center')) {
    return 'asset';
  }

  const match = TOP_NAV_ITEMS.find((item) => pathname.startsWith(item.path));
  return match?.key;
};
